import { DefaultHttpClient, HttpClient } from "../utils";

export const HTTP_CLIENT: HttpClient = new DefaultHttpClient();
